import { AiToolOffice } from '../../../common/ai-details/ai-tool-office';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { LoaderService } from '../../loader/loader.service';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import * as jwt_decode from 'jwt-decode';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { SaveUpdateMemoryCardTemplateComponent } from 'src/app/middleware/common/saveUpdateMemoryCardTemplate/saveUpdateMemoryCardTemplate.component';
import { MemoryCardDetailsComponent } from 'src/app/middleware/common/memoryCardDetails/memoryCardDetails.component';
import { finalize } from 'rxjs/operators';

enum StatusEnum {
  Fail = 0,
  Pass = 1,
  FollowUp = 2
}

@Component({
  selector: 'app-qualifyingQuestion',
  templateUrl: './qualifyingQuestion.component.html',
  styleUrls: ['./qualifyingQuestion.component.scss']
})
export class QualifyingQuestionComponent implements OnInit, OnChanges {

  @Input() transactionID: number = 0;
  @Input() documentsId: number = 0;
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;

  responseHolder: any = [] = [];
  organizationId: string;
  databaseId: string;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) expansionPanel: QueryList<MatExpansionPanel>;
  openpanel: number;
  step = 0;
  currentAnswerChooseIndex: any;

  menuModulesList: any;
  CoreShowName: any;

  ThresholdList: any = [] = [];

  Recommendation: string = "";
  qualifyResult: number = 0;
  overAllContribution: number = 0;
  thresholdValue: number = 0;

  showEvidence = false;
  followUpNotes = '';
  status: 'Pass' | 'Fail' | 'Follow Up';
  questionID: number = 0;
  statusforQuestion: number = 0;
  formDialog: FormGroup;

  constructor(private _dataSharingService: DataSharingService, private formsService: FormsService, private loaderService: LoaderService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private toastr: ToastrService,
    private dialog: MatDialog, private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules') ?? '[]');
    let SelectedCore = this.menuModulesList.filter((x: any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
    });
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.getThresholdRules();
  }



  selectedEvidenceIndex: number | null = null;

  toggleEvidence(index: number) {
    this.selectedEvidenceIndex = this.selectedEvidenceIndex === index ? null : index;
  }


  // toggleEvidence() {
  //   this.showEvidence = !this.showEvidence;
  // }

  getThresholdRules() {
    var ReqModel = {
      coreID: this.transactionID,
      documentID: this.documentsId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.getReferralQuestionAnswers(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ThresholdList = this.responseHolder.data.questions;
          this.qualifyResult = this.responseHolder.data.qualifyResult;
          this.overAllContribution = this.responseHolder.data.overAllContribution;
          this.thresholdValue = this.responseHolder.data.thresholdValue;

          if (this.qualifyResult == 0) {
            this.Recommendation = "Fail";
          }
          if (this.qualifyResult == 1) {
            this.Recommendation = "Pass";
          }
          if (this.qualifyResult == 2) {
            this.Recommendation = "Follow Up";
          }

          if (this.ThresholdList.length > 0) {
            this.ThresholdList.forEach((e: any) => {

              //=== Fail ===//
              if (e.finalResult == 0) {
                e.statusName = "Fail";
                e.value = 0.0;
              }
              //=== Pass ===//
              if (e.finalResult == 1) {
                e.statusName = "Pass";
                e.value = 1.0;
              }
              //=== Follow Up ===//
              if (e.finalResult == 2) {
                e.statusName = "FollowUp";
                e.value = 0.5;
              }

              if (e.aiResult == 0) {
                e.aiResultName = "Fail";
                e.value = 0.0;
              }
              //=== Pass ===//
              if (e.aiResult == 1) {
                e.aiResultName = "Pass";
                e.value = 1.0;
              }
              //=== Follow Up ===//
              if (e.aiResult == 2) {
                e.aiResultName = "FollowUp";
                e.value = 0.5;
              }

              // === Contribution Calculation ===//
              // const weight = e?.weight ?? 0;
              // const value = e?.value ?? 0;
              // e.contribution = +(weight * value).toFixed(1);
            });
          }
        } else {
          this.ThresholdList = [];
          this.loaderService.hide();
        }
      } else {
        this.ThresholdList = [];
        this.loaderService.hide();
      }
    });
  }




  onStatusChange(value: string, item: any) {
    this.statusforQuestion = 0;
    if (value == "Fail") {
      this.statusforQuestion = 0;
    }
    if (value == "Pass") {
      this.statusforQuestion = 1;
    }
    if (value == "FollowUp") {
      this.statusforQuestion = 2;
    }
    var ReqModel = {
      questionID: Number(item.quetionID),
      status: this.statusforQuestion,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.changeStatusForReferralQuestion(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Status changed successfully.', '', {
            timeOut: 3000,
          });
          this.getThresholdRules();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  close() {
    this.dialog.closeAll();
  }



  openaiAnswer(templateRef: TemplateRef<any>, temp: any) {
    this.questionID = temp.quetionID;
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('aiAnswer', this.formBuilder.control(''));
    this.formDialog.controls['aiAnswer'].setValue(temp.aiAnswer);
    this.dialog.open(templateRef, {
      panelClass: 'addAiModalBox',
    });
  }


  updateaiAnswer(data: any) {
    if (data.aiAnswer == '' || data.aiAnswer == null) {
      this.toastr.warning('Please add Answer.', '', {
        timeOut: 3000,
      });
      return;
    }

    var ReqModel = {
      questionID: this.questionID,
      aiAnswer: data.aiAnswer,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.loaderService.show();
    this.formsService.changeAIAnswerForReferralQuestion(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('AI answer updated successfully.', '', {
            timeOut: 3000,
          });
          this.getThresholdRules();
          this.close();
        } else {
          this.close();
          this.loaderService.hide();
        }
      } else {
        this.close();
        this.loaderService.hide();
      }
    });
  }

  viewMemoryCard(item: any) {
    const dialogRef = this.dialog.open(MemoryCardDetailsComponent, {
      data: {
        memoryCardName: item.memoryCard.memoryCardName,
        memoryDescription: item.memoryCard.memoryDescription,
      },
      width: '45vw',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

      }
    });
  }



  onFollowUpChange(item: any, action: string): void {

    const flagMap: { [key: string]: number } = {
      'Accept': 1,//Pass
      'Review': 2,//Followup
      'Reject': 3 //Fail
    };

    const followUpFlagResult = flagMap[action];

    if (!followUpFlagResult) {
      return;
    }

    item.followUpFlagResult=followUpFlagResult;

    const reqModel = {
      questionID: item.quetionID,
      flag: followUpFlagResult,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    };

    this.loaderService.show();

    this.formsService
      .changeFollowupFlagForReferralQuestion(reqModel)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe({
        next: (response: any) => {
          if (response?.status === this.statusConst.statusSuccess) {
            this.toastr.success('Flag updated successfully.', '', {
              timeOut: 3000
            });

            this.getThresholdRules();
          } else {
            this.toastr.error(response?.message || 'Unable to update flag.');
          }
        },
        error: (error) => {
          console.error(error);
          this.toastr.error('Something went wrong. Please try again.');
        }
      });
  }


}
